import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CmsService } from '@services/cms.service';

@Component({
  selector: 'app-terms-and-conditions-modal',
  templateUrl: './terms-and-conditions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TermsAndConditionsComponent {
  @Output() closeModal = new EventEmitter<void>();

  private readonly cmsService = inject(CmsService);

  protected readonly termAndConditions = toSignal(this.cmsService.getCmsNotification('tnc'));
  protected isWebview: boolean = false;
  ngOnInit() {
    const userAgent = navigator.userAgent.toLowerCase();
    let safari = /safari/.test(userAgent);
    let ios = /iphone|ipod|ipad/.test(userAgent);
    if (userAgent.indexOf('wv') > -1 || userAgent.indexOf('webview') > -1 || (!safari && ios)) {
      this.isWebview = true;
    }
  }
}
